import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-50">
                91<span className="text-primary-400">制片厂</span>
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              专注优质影视内容创作与发行的专业平台，汇聚海量原创视频资源，为用户提供高清流畅的观看体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              <a href="#footer-categories" className="text-foreground-50 no-underline">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              <a href="#footer-quick-links" className="text-foreground-50 no-underline">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  会员服务
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  创作者入驻
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              <a href="#footer-contact" className="text-foreground-50 no-underline">联系我们</a>
            </h4>
            <ul className="space-y-3 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-base text-primary-400 mt-0.5"></i>
                <span>service@91pianzhi.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-base text-primary-400 mt-0.5"></i>
                <span>400-xxx-xxxx</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base text-primary-400 mt-0.5"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/50">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2024 91制片厂 版权所有 | 京ICP备xxxxxxxx号 | 广播电视节目制作经营许可证
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-200 text-xs transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 text-xs transition-colors" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 text-xs transition-colors" rel="nofollow">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}